import {
  ApiPropertyOptional,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ValidateNested } from 'class-validator';
import { JobNoteCreatableInterface } from '../interfaces/job-note-creatable.interface';
import { JobNoteDto } from './job-note.dto';
import { JobNoteOptionCascadeDto } from '../../job-note-option/dtos/job-note-option-cascade.dto';

export class JobNoteCreateDto
  extends IntersectionType(
    PickType(JobNoteDto, ['jobId']),
    PartialType(PickType(JobNoteDto, ['note'])),
  )
  implements JobNoteCreatableInterface
{
  @ApiPropertyOptional({
    type: () => [JobNoteOptionCascadeDto],
    title: 'Associated Job Note Options',
    description: 'The options associated with this job note',
  })
  @Expose()
  @Type(() => JobNoteOptionCascadeDto)
  @ValidateNested({ each: true })
  jobNoteOptions?: JobNoteOptionCascadeDto[];
}
